<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      floating
      app
      :mini-variant-width="$vuetify.breakpoint.mdAndUp ? '4vw' : '12vw'"
      :mini-variant.sync="mini"
      :mini="mini"
      style="background-color: whitesmoke"
    >
      <v-list class="transparent" nav>
        <v-list-item class="mt-2">
          <v-img
            contain
            height="7vh"
            :src="
              mini
                ? require('@/assets/images/logo_pitch.webp')
                : require('@/assets/icons/connect_logo_bar.svg')
            "
          />
        </v-list-item>
      </v-list>
      <v-list class="d-flex align-center justify-start">
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-avatar size="40" rounded>
              <v-img contain height="2vh" src="@/assets/icons/home.svg"></v-img>
            </v-list-item-avatar>

            <v-list-item-title>Cockpit</v-list-item-title>
          </template>
          <v-list-item class="d-flex align-center justify-start">
            <v-list-item-avatar size="40" rounded>
              <v-img height="2vh" contain src="@/assets/icons/document.svg" />
            </v-list-item-avatar>
            <router-link :to="`${module}/cockpit`">
              <v-list-item-title>Paniel</v-list-item-title>
            </router-link>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list class="d-flex align-center justify-start">
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-avatar size="40" rounded>
              <v-img
                contain
                height="2vh"
                src="@/assets/icons/course.svg"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-title>Curso</v-list-item-title>
          </template>
          <v-list-item custom class="d-flex align-center justify-start">
            <v-list-item-avatar size="40" rounded>
              <v-icon height="2vh">mdi-folder</v-icon>
            </v-list-item-avatar>
            <router-link :to="`${module}/curso`">
              <v-list-item-title>Módulos</v-list-item-title>
            </router-link>
          </v-list-item>
          <v-list-item
            custom
            class="d-flex align-center justify-start"
            v-if="module === 'aluno'"
          >
            <v-list-item-avatar size="40" rounded>
              <v-icon height="2vh">mdi-file-outline</v-icon>
            </v-list-item-avatar>
            <router-link :to="`${module}/curso`">
              <v-list-item-title>Certificados</v-list-item-title>
            </router-link>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list class="d-flex align-center justify-start">
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-avatar size="40" rounded>
              <v-img
                contain
                height="2vh"
                src="@/assets/icons/document.svg"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-title>Turmas</v-list-item-title>
          </template>
          <v-list-item custom class="d-flex align-center justify-start">
            <v-list-item-avatar size="40" rounded>
              <v-icon>mdi-google-classroom</v-icon>
            </v-list-item-avatar>
            <router-link :to="`${module}/turmas`">
              <v-list-item-title>Minhas Turmas</v-list-item-title>
            </router-link>
          </v-list-item>
          <v-list-item custom class="d-flex align-center justify-start">
            <v-list-item-avatar size="40" rounded>
              <v-icon height="2vh">mdi-book-variant</v-icon>
            </v-list-item-avatar>
            <router-link :to="`${module}/agenda`">
              <v-list-item-title>Minhas Aulas</v-list-item-title>
            </router-link>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list class="d-flex align-center justify-start">
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-avatar size="40" rounded>
              <v-img
                contain
                height="2vh"
                src="@/assets/icons/calendar.svg"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-title>Agenda</v-list-item-title>
          </template>
          <v-list-item custom class="d-flex align-center justify-start">
            <v-list-item-avatar size="40" rounded>
              <v-icon height="2vh">mdi-calendar</v-icon>
            </v-list-item-avatar>
            <router-link :to="`${module}/agenda`">
              <v-list-item-title>Eventos</v-list-item-title>
            </router-link>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list class="d-flex align-center justify-start">
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-avatar size="40" rounded>
              <v-img
                contain
                height="2vh"
                src="@/assets/icons/wallet.svg"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-title>Financeiro</v-list-item-title>
          </template>
          <v-list-item custom class="d-flex align-center justify-start">
            <v-list-item-avatar size="40" rounded>
              <v-icon height="2vh">mdi-credit-card</v-icon>
            </v-list-item-avatar>
            <router-link :to="`${module}/financeiro`">
              <v-list-item-title>Pagamentos</v-list-item-title>
            </router-link>
          </v-list-item>
          <v-list-item custom class="d-flex align-center justify-start">
            <v-list-item-avatar size="40" rounded>
              <v-icon height="2vh">mdi-hand-coin-outline</v-icon>
            </v-list-item-avatar>
            <router-link :to="`${module}/financeiro`">
              <v-list-item-title>Pitch Coins</v-list-item-title>
            </router-link>
          </v-list-item>
          <v-list-item custom class="d-flex align-center justify-start">
            <v-list-item-avatar size="40" rounded>
              <v-icon height="2vh">mdi-lightning-bolt-outline</v-icon>
            </v-list-item-avatar>
            <router-link :to="`${module}/financeiro`">
              <v-list-item-title>Promoções</v-list-item-title>
            </router-link>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider class="ma-0 pa-0"></v-divider>

      <v-list class="transparent mt-2 fill-width" style="height: 50vh" nav>
        <router-link :to="`${this.module}/notificacoes`" custom>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                link
                v-bind="attrs"
                v-on="on"
                class="mb-4 pb-5 px-0 pt-4 d-flex align-center"
                style="max-height: 4vh !important"
              >
                <v-list-item-avatar rounded>
                  <v-badge
                    v-if="$store.getters.user.notificationsCount"
                    overlap
                    dense
                    :class="{
                      pulse:
                        $store.getters.user.notificationsCount !== 0 ||
                        $store.getters.user.notificationsCount !== null,
                    }"
                    :content="
                      $store.getters.user.notificationsCount
                        ? $store.getters.user.notificationsCount
                        : 0
                    "
                  >
                    <v-icon style="background-color: transparent"
                      >mdi-bell-outline</v-icon
                    >
                  </v-badge>
                  <v-icon style="background-color: transparent" v-else
                    >mdi-bell-outline</v-icon
                  >
                </v-list-item-avatar>
                <v-list-item-content class="d-flex align-center">
                  <v-list-item-title>Notificações</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <span> Notificações </span>
          </v-tooltip>
        </router-link>
        <router-link :to="`${this.module}/perfil`" custom>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                link
                v-bind="attrs"
                v-on="on"
                class="mb-4 pb-5 px-0 pt-4 d-flex align-center"
                style="max-height: 4vh !important"
              >
                <v-list-item-avatar size="40" rounded v-if="avatar">
                  <v-img
                    contain
                    alt="avatar"
                    :src="avatar"
                    style="border-radius: 30px"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-avatar size="40" rounded v-else>
                  <v-avatar size="40" color="primary">
                    <strong class="white--text">{{ customerInitials }}</strong>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content class="d-flex align-center">
                  <v-list-item-title>Perfil</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <span> Perfil </span>
          </v-tooltip>
        </router-link>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              link
              v-bind="attrs"
              v-on="on"
              class="mb-4 pb-5 px-0 pt-4"
              @click="logoff"
              style="max-height: 4vh !important"
            >
              <v-list-item-avatar size="40" rounded>
                <v-img
                  contain
                  height="3vh"
                  src="@/assets/icons/exit.svg"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="'Logout'"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>Logout</span>
        </v-tooltip>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <slot />
    </v-main>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "PitchEnglishHomeApplicationTemplate",

  data() {
    return {
      drawer: true,
      module: `/connect/${store.getters.module}`,
      avatar: store.getters.user.avatar,
      mini: false,
    };
  },

  computed: {
    customerInitials() {
      return localStorage.getItem("initials");
    },
  },

  mounted() {},

  methods: {
    logoff() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("module");
      this.$router.push({
        path: "/connect",
      });
    },
  },
};
</script>
